<template>
  <div class="page">
    <div class="screenLine">
      <el-input
        @keyup.enter.native="handelComClick"
        v-model="keyword"
        clearable
        placeholder="客户/电话"
        @change="handelComClick"
        style="width: 240px; margin-right: 16px"
      ></el-input>
      <div>预约日期：</div>

      <el-date-picker
        v-model="date"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        style="margin-right: 16px"
        @change="handelComClick"
      >
      </el-date-picker>
      <div>预约类型：</div>
      <el-select
        v-model="type"
        placeholder="申请状态"
        class="titleSelect"
        @change="handelComClick"
      >
        <el-option
          v-for="item in types"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <div>预约状态：</div>
      <el-select
        v-model="state"
        placeholder="申请状态"
        class="titleSelect"
        @change="handelComClick"
      >
        <el-option
          v-for="item in stateList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <el-button type="warning" plain @click="handleResetClick">重置</el-button>
    </div>
    <div class="tableBox">
      <el-table :data="tableData" style="width: 100%; height: 100%">
        <el-table-column prop="time_info.date" label="预约日期">
        </el-table-column>
        <el-table-column prop="type" label="预约类型">
          <template slot-scope="scope">
            <span v-if="scope.row.type == 1">接宠</span>
            <span v-if="scope.row.type == 2">送宠</span>
          </template>
        </el-table-column>
        <el-table-column prop="time_info.start_time" label="预约时间">
          <template slot-scope="scope">
            <span v-if="scope.row.time_info">{{
              scope.row.time_info.start_time.split(" ")[1]
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="user_info.user_name" label="预约客户">
        </el-table-column>
        <el-table-column prop="user_info.user_mobile" label="预约电话">
        </el-table-column>
        <el-table-column prop="remark" label="预约备注"> </el-table-column>
        <el-table-column prop="state" label="预约状态">
          <template slot-scope="scope">
            <span v-if="scope.row.state == 1">已提交</span>
            <span v-if="scope.row.state == 2">已审核</span>
            <span v-if="scope.row.state == 3">待接送</span>
            <span v-if="scope.row.state == 4">接送中</span>
            <span v-if="scope.row.state == 5">已完成</span>
            <span v-if="scope.row.state == -2">已取消</span>
          </template>
        </el-table-column>
        <el-table-column label="操作时间">
          <template slot-scope="scope">{{
            $public.FTime(scope.row.create_time, "YYYY-MM-DD HH:mm:ss")
          }}</template>
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="handleSeeClick(scope.row)"
              >查看</el-button
            >
            <el-button
              type="text"
              size="small"
              @click="handleDelClick(scope.row)"
              v-if="scope.row.state == -2"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="paging">
        <el-pagination
          background
          @current-change="changePage"
          :current-page="page.page"
          :page-size="page.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="page.total"
        ></el-pagination>
      </div>
    </div>

    <div v-if="drawerpetShuttle_state">
      <petShuttleDetail
        :id="id"
        @close="drawerpetShuttle_state = false"
        @submit="submit_drawerpetShuttle"
      >
      </petShuttleDetail>
    </div>
  </div>
</template>
    
<script>
import petShuttleDetail from "./petShuttleDetail.vue";

export default {
  components: {
    petShuttleDetail,
  },
  data() {
    return {
      page: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      id: "",
      type: "0",
      date: [], //日期
      state: "0",
      keyword: "", //关键字
      tableData: [], //订单列表
      stateList: [
        { label: "全部", value: "0" },
        { label: "已提交", value: "1" },
        { label: "已审核", value: "2" },
        { label: "接送中", value: "4" },
        { label: "已完成", value: "5" },
        { label: "已取消", value: "-2" },
      ],
      types: [
        { label: "全部", value: "0" },
        { label: "接宠", value: "1" },
        {
          label: "送宠",
          value: "2",
        },
      ],
      drawerpetShuttle_state: false,
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    // 删除
    handleDelClick(row) {
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .get(process.env.VUE_APP_AppAdmin + "/api/PetShuttle/Delete", {
              id: row.id,
            })
            .then((res) => {
              if (res.code == 0) {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
                this.page.page = 1;
                this.getTableData();
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 查看
    handleSeeClick(row) {
      this.id = row.id;
      this.drawerpetShuttle_state = true;
    },
    submit_drawerpetShuttle() {
      this.drawerpetShuttle_state = false;
      this.page.page = 1;
      this.getTableData();
    },
    getTableData() {
      let params = {
        pageIndex: this.page.page,
        pageSize: this.page.pageSize,
        keyWord: this.keyword,
        sort: "",
        state: this.state, // 状态  1 已提交 2 已审核 3 带接送 4 接送中 5已完成 -2 已取消
        shop_id: this.$store.state.shopId,
        type: this.type,
      };
      if (this.date != "") {
        params.shuttle_begin = this.$public.FTimeStr10(this.date[0]);
        params.shuttle_end = this.$public.FTimeStr10(this.date[1]);
      }
      this.$http
        .post(process.env.VUE_APP_AppAdmin + "/api/PetShuttle/GetList", params)
        .then((res) => {
          if (res.code == 0) {
            console.log(res, "???");
            this.tableData = res.data.list;
            this.page.total = res.data.count;
          }
        });
    },
    // 搜索
    handelComClick() {
      this.page.page = 1;
      if (this.date == null) {
        this.date = [];
      }
      this.getTableData();
    },
    //重置
    handleResetClick() {
      this.page.page = 1;
      this.keyword = "";
      this.state = "0";
      this.type = "0";
      this.date = [];
      this.getTableData();
    },
    // 分页方法
    changePage(num) {
      this.page.page = num;
      this.getTableData();
    },
  },
};
</script>
    
<style lang="scss" scoped>
.page {
  padding: 16px 16px 65px 16px;
  height: 100%;
  box-sizing: border-box;
  position: relative;
  .screenLine {
    display: flex;
    align-items: center;
    .titleSelect {
      width: 130px;
      margin-right: 16px;
    }
  }
  .tableBox {
    padding: 16px;
    border-radius: 8px;
    background-color: #fff;
    box-sizing: border-box;
    margin-top: 16px;
    height: calc(100% - 56px);
  }
}
</style>
